import React from "react";

const InputErrorMessage = ({ message }) => (
  <div className="input__error-message">{message}</div>
);

export default InputErrorMessage;
